import React from 'react';

import { IconName } from 'components/core/Icon/Icon';
import { StyledButton, StyledIcon } from 'components/widgets/customerSupport/sharedStyle';
import { getHostedPageFlowType } from 'utilities/global';
import { openLinkInNewTab } from 'utilities/window';
import { Tracker } from 'shared/services/tracking';
import { ThemeFamilies } from 'models';
import { GA_ACTIONS, GA_LABEL } from 'consts';

interface IProps {
  email: string;
}

const CustomerSupportEmail = ({ email }: IProps) => {
  const tracker = new Tracker(getHostedPageFlowType());

  const handleEmailClick = () => {
    tracker.fireEvent({
      category: `${GA_ACTIONS.CUSTOMER_SUPPORT} - ${GA_LABEL.EMAIL}`,
      action: GA_ACTIONS.CUSTOMER_SUPPORT
    });
    const mailtoLink = `mailto:${email}`;
    openLinkInNewTab(mailtoLink);
  };

  return (
    <StyledButton themeFamily={ThemeFamilies.BORDERED_PRIMARY} onClick={handleEmailClick}>
      <StyledIcon name={IconName.ENVELOP} />
    </StyledButton>
  );
};

export default CustomerSupportEmail;
